<template>

    <form ref="tutorialvideotag-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12">
                <label for="nomeTag">Tag</label>
                <input type="text" class="form-control" name="nomeTag" v-model="model.nomeTag" required />
            </div>
        </div>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "tutorialvideotag-form-create",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "tutorialvideotag-form-create",

            resources: {
                create: 'tutorialvideotag',
            },

        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                model.tutorialVideoId = this.id;
                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

